import { useTranslation } from 'react-i18next';
import { PropertyStatusesEnum } from 'dash-common';
import { Box, DropdownOptions, Flex, FormContext, FormProvider, TooltipPopup } from 'dash-ui';

import Properties from 'containers/properties/Properties/Properties';
import Container from 'flow-components/Container/Container';
import Header from 'flow-components/Header/Header';
import DeliveryImage from 'assets/images/png/Delivery.png';
import SearchingImage from 'assets/images/png/Searching.png';
import {
  useGetCurrentDeveloperUserQuery,
  useGetMarketAreasQuery,
  useGetUsStatesQuery,
} from 'gql/generated.graphql';
import { useContext, useMemo } from 'react';
import { FormFieldsList } from './constants/constants';

function PropertiesPageBase() {
  const { t } = useTranslation(['tables']);
  const { data } = useGetCurrentDeveloperUserQuery();
  const { data: statesData } = useGetUsStatesQuery({
    variables: {
      filter: {
        withMarketArea: true,
      }
    }
  });
  const { formState } = useContext(FormContext);

  const statesOptions = useMemo(() => {
    const states = statesData?.getUSStates || [];
    return states.map(({ name }) => ({
      value: name,
      label: name,
    }));
  }, [statesData]);
  const organizationsOptions = useMemo(() => {
    const { organizations = [] } = data?.getCurrentDeveloperUser || {};

    return organizations?.map(({ _id, name }) => ({ _id, name })) || [];
  }, [data]);

  const { data: result } = useGetMarketAreasQuery({
    variables: {
      filter: {
        stateNames: formState.state && [formState.state],
      },
      pagination: {
        allowLimit: false,
      },
      sort: {
        fieldName: 'name',
        sortOrder: 1,
      },
    },
  });

  const { marketAreas } = useMemo(
    () => ({
      marketAreas: result?.getMarketAreas?.collection || [],
    }),
    [result]
  );

  const marketOptions = useMemo(() => {
    return marketAreas.map(({ _id, name }) => ({
      value: _id,
      label: name,
    }));
  }, [marketAreas]);

  return (
    <Box h="100%">
      <DropdownOptions />
      <TooltipPopup />
      <Header />
      <Container>
        <Flex flexDirection="column" flex={1} w="100%">
            <Properties
              filter={{}}
              tableProps={{
                hideColumns: [],
                actionProps: {
                  withStatusFilter: true,
                  withOrganizationsFilter: organizationsOptions?.length > 1,
                  withCreateAction: false,
                  excludeStatuses: [PropertyStatusesEnum.DRAFT],
                  organizations: organizationsOptions,
                  statesOptions,
                  marketOptions,
                },
                placeholder: t('tables:properties:placeholder') || '',
                placeholderImage: DeliveryImage,
                searchPlaceholder: t('tables:properties:placeholderSearch') || '',
                searchPlaceholderImage: SearchingImage,
              }}
            />
        </Flex>
      </Container>
    </Box>
  );
}

function PropertiesPage() {
  return (
    <FormProvider fieldsList={FormFieldsList}>
      <PropertiesPageBase />
    </FormProvider>
  );
}

export default PropertiesPage;
